"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var add_event_listener_1 = require("./utils/add-event-listener");
var create_chained_function_1 = require("./utils/create-chained-function");
var owner_document_1 = require("./utils/owner-document");
// TODO: Consider using an ES6 symbol here, once we use babel-runtime.
var CLICK_WAS_INSIDE = '__click_was_inside';
var counter = 0;
function isLeftClickEvent(event) {
    return event.button === 0;
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function getSuppressRootClose() {
    var id = CLICK_WAS_INSIDE + '_' + counter++;
    return {
        id: id,
        suppressRootClose: function (event) {
            // Tag the native event to prevent the root close logic on document click.
            // This seems safer than using event.nativeEvent.stopImmediatePropagation(),
            // which is only supported in IE >= 9.
            event.nativeEvent[id] = true;
        }
    };
}
var RootCloseWrapper = /** @class */ (function (_super) {
    __extends(RootCloseWrapper, _super);
    function RootCloseWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.getWrappedDOMNode = function () {
            // We can't use a ref to identify the wrapped child, since we might be
            // stealing the ref from the owner, but we know exactly the DOM structure
            // that will be rendered, so we can just do this to get the child's DOM
            // node for doing size calculations in OverlayMixin.
            var node = ReactDOM.findDOMNode(_this);
            return _this.props.noWrap ? node : node.firstChild;
        };
        _this.bindRootCloseHandlers = function () {
            var doc = owner_document_1.ownerDocument(_this);
            _this._onDocumentMouseListener =
                add_event_listener_1.addEventListener(doc, _this.props.event, _this.handleDocumentMouse);
            _this._onDocumentKeyupListener =
                add_event_listener_1.addEventListener(doc, 'keyup', _this.handleDocumentKeyUp);
        };
        _this.handleDocumentMouse = function (e) {
            // This is now the native event.
            if (e[_this._suppressRootId]) {
                return;
            }
            if (_this.props.disabled || isModifiedEvent(e) || !isLeftClickEvent(e)) {
                return;
            }
            _this.props.onRootClose &&
                _this.props.onRootClose();
        };
        _this.handleDocumentKeyUp = function (e) {
            if (e.keyCode === 27 && _this.props.onRootClose) {
                _this.props.onRootClose();
            }
        };
        _this.unbindRootCloseHandlers = function () {
            if (_this._onDocumentMouseListener) {
                _this._onDocumentMouseListener.remove();
            }
            if (_this._onDocumentKeyupListener) {
                _this._onDocumentKeyupListener.remove();
            }
        };
        _this.handleDocumentMouse = _this.handleDocumentMouse.bind(_this);
        _this.handleDocumentKeyUp = _this.handleDocumentKeyUp.bind(_this);
        var _a = getSuppressRootClose(), id = _a.id, suppressRootClose = _a.suppressRootClose;
        _this._suppressRootId = id;
        _this._suppressRootCloseHandler = suppressRootClose;
        return _this;
    }
    RootCloseWrapper.prototype.componentDidMount = function () {
        this.bindRootCloseHandlers();
    };
    RootCloseWrapper.prototype.componentWillUnmount = function () {
        this.unbindRootCloseHandlers();
    };
    RootCloseWrapper.prototype.render = function () {
        var _a = this.props, event = _a.event, noWrap = _a.noWrap, children = _a.children;
        var child = React.Children.only(children);
        var handlerName = event == 'click' ? 'onClick' : 'onMouseDown';
        if (noWrap) {
            return React.cloneElement(child, (_b = {},
                _b[handlerName] = create_chained_function_1.createChainedFunction(this._suppressRootCloseHandler, child.props[handlerName]),
                _b));
        }
        // Wrap the child in a new element, so the child won't have to handle
        // potentially combining multiple onClick listeners.
        return (React.createElement("div", __assign({}, (_c = {}, _c[handlerName] = this._suppressRootCloseHandler, _c)), child));
        var _b, _c;
    };
    RootCloseWrapper.propTypes = {
        onRootClose: PropTypes.func,
        disabled: PropTypes.bool,
        noWrap: PropTypes.bool,
        event: PropTypes.oneOf(['click', 'mousedown'])
    };
    RootCloseWrapper.defaultProps = {
        event: 'click'
    };
    return RootCloseWrapper;
}(React.Component));
exports.RootCloseWrapper = RootCloseWrapper;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-overlays/root-close-wrapper.js
// module id = 195
// module chunks = 0 1 2 3 4 5 6